<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 数据查询区：表单 -->
      <div class="search-wrapper">
        <el-form :model="queryParams" ref="queryRef" :inline="true">
          <el-form-item label="搜索关键字" prop="key">
            <el-input
              v-model="queryParams.key"
              placeholder="输入名称"
              clearable
              @keyup.enter="handleQuery"
            />
          </el-form-item>
          <el-form-item label="标准类型" prop="level">
            <el-select
              v-model="queryParams.level"
              placeholder="全部类型"
              clearable
              style="width: 240px"
            >
              <el-option label="国家级" value="国家级" />
              <el-option label="省级" value="省级" />
              <el-option label="市级" value="市级" />
              <el-option label="企业级" value="企业级" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="Search" @click="handleQuery"
              ><Search />搜索</el-button
            >
            <el-button icon="Refresh" @click="resetQuery(queryRef)"
              ><Refresh />重置</el-button
            >
            <!-- <button @click="startGuide">开始引导</button> -->
          </el-form-item>
        </el-form>
      </div>

      <!-- 数据操作区：按钮 -->
      <div class="operation-wrapper">
        <el-row :gutter="10" class="mb8">
          <el-col :span="1.5">
            <el-button type="primary" plain icon="Plus" @click="handleAdd"
              >新增</el-button
            >
          </el-col>
          <el-col :span="1.5">
            <el-button
              type="danger"
              plain
              icon="Delete"
              @click="handleDeleteBatch"
              :disabled="!multiple"
              >批量删除</el-button
            >
          </el-col>
        </el-row>
      </div>
      <!-- 数据展示区：表格 -->
      <div class="table-wrapper">
        <el-table
          v-loading="loading"
          :data="dataList"
          @selection-change="handleSelectionChange"
          class="custom-table"
        >
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column
            label="标准名称"
            align="center"
            width="150"
            prop="standardName"
          />
          <el-table-column
            label="标准编号"
            align="center"
            width="80"
            prop="standardNumber"
          />
          <el-table-column label="标准级别" prop="level" align="center" />
          <el-table-column
            label="归口单位"
            align="center"
            prop="responsibleUnit"
          />
          <el-table-column
            label="发布部门"
            align="center"
            width="150"
            prop="departmentName"
          />
          <el-table-column
            label="起草人"
            align="center"
            width="150"
            prop="draftAuthor"
          />
          <el-table-column
            label="起草单位"
            align="center"
            width="150"
            prop="draftUnit"
          />
          <el-table-column
            label="发布日期"
            align="center"
            prop="publicationDate"
          >
            <template #default="{ row }">{{
              formatDateTime(row.publicationDate)
            }}</template>
          </el-table-column>
          <el-table-column
            label="实施日期"
            align="center"
            prop="implementationDate"
          >
            <template #default="{ row }">{{
              formatDateTime(row.implementationDate)
            }}</template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="200"
            fixed="right"
          >
            <template #default="scope">
              <div class="operation-buttons">
                <!-- 第一行按钮 -->
                <div class="button-group">
                  <el-button
                    type="primary"
                    link
                    size="small"
                    @click="handleUpdate(scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    type="danger"
                    link
                    size="small"
                    @click="handleDelete(scope.row)"
                    >删除</el-button
                  >
                  <el-button
                    type="info"
                    link
                    size="small"
                    @click="handleView(scope.row)"
                    >查看</el-button
                  >
                  <el-button
                    type="success"
                    link
                    size="small"
                    @click="handleBrowse(scope.row)"
                    >浏览</el-button
                  >
                </div>

                <!-- 第二行按钮 -->
                <div class="button-group">
                  <el-button
                    type="success"
                    link
                    size="small"
                    @click="handleDesign(scope.row)"
                    >前去设计</el-button
                  >
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 数据展示区：分页加载 -->
      <div class="pagination-wrapper">
        <el-pagination
          style="margin-top: 20px"
          v-model:current-page="queryParams.page"
          v-model:page-size="queryParams.pageSize"
          :page-sizes="[10, 20, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>

      <!-- 数据编辑区：新增/修改对话框 -->
      <StandardForm
        v-model:open="dialogVisible"
        :title="editingStandard ? '编辑标准' : '新增标准'"
        :edit-data="editingStandard"
        @refresh-list="getList"
      />
      <el-drawer
        v-model="drawer"
        title="查看标准详情"
        direction="rtl"
        size="600px"
      >
        <el-descriptions :title="standardTitle" :column="1" border>
          <el-descriptions-item label="标准名称">{{
            standard.standardName
          }}</el-descriptions-item>
          <el-descriptions-item label="标准编号">{{
            standard.standardNumber
          }}</el-descriptions-item>
          <el-descriptions-item label="标准级别">{{
            standard.level
          }}</el-descriptions-item>
          <el-descriptions-item label="归口单位">{{
            standard.responsibleUnit
          }}</el-descriptions-item>
          <el-descriptions-item label="发布部门">{{
            standard.departmentName
          }}</el-descriptions-item>
          <el-descriptions-item label="起草人">{{
            standard.draftAuthor
          }}</el-descriptions-item>
          <el-descriptions-item label="起草单位">{{
            standard.draftUnit
          }}</el-descriptions-item>
          <el-descriptions-item label="适用范围">{{
            standard.scope
          }}</el-descriptions-item>
          <el-descriptions-item label="规范性引用文件">{{
            standard.normativeDocuments
          }}</el-descriptions-item>
          <el-descriptions-item label="发布日期">{{
            formatDateTime(standard.publicationDate)
          }}</el-descriptions-item>
          <el-descriptions-item label="实施日期">{{
            formatDateTime(standard.implementationDate)
          }}</el-descriptions-item>
          <el-descriptions-item label="图片">
            <div class="image-preview-list" v-if="standard.imageList?.length">
              <el-image
                v-for="(url, index) in standard.imageList"
                :key="index"
                style="width: 100px; height: 100px; margin-right: 10px"
                :src="url"
                fit="cover"
                :preview-src-list="standard.imageList"
              />
            </div>
            <span v-else>暂无图片</span>
          </el-descriptions-item>
          <el-descriptions-item label="相关文件">
            <div v-if="standard.file">
              <a :href="completeFileUrl" target="_blank">
                {{ standard.fileName }}
              </a>
              <!-- <el-button type="primary" @click="handleDownload(completeFileUrl)">下载</el-button>  -->
            </div>
            <div v-else>暂无文件</div>
          </el-descriptions-item>
        </el-descriptions>
      </el-drawer>
    </el-card>
  </div>
</template>

<script lang="ts" setup>
/** ------------------全局导入区-------------------- */
import { ref, reactive, toRef, onMounted, computed } from "vue";
import type { FormInstance, FormRules } from "element-plus";
import { ElMessage, ElMessageBox } from "element-plus";
import type { QueryParams, StandardDTO, RuleForm } from "@/types/type";
import StandardForm from "@/standard/StandardForm.vue";
import {
  listStandardByPage,
  deleteStandardBatch,
  deleteStandard,
  updateStandard,
} from "@/api/standard";
import { getStandardById } from "@/api/menu";
import { useRouter } from "vue-router";
import dayjs from "dayjs";

onMounted(() => {
  // 挂载后加载数据
  getList();
});
// 添加日期格式化函数
// 修改 formatDate 函数的类型定义
const formatDateTime = (date: string | Date | null | undefined) => {
  if (!date) return "";
  return dayjs(date).format("YYYY-MM-DD");
};

// 新增浏览处理方法
const handleBrowse = (row: StandardDTO) => {
  router.push({
    path: "/content",
    query: { id: row.id },
  });
};
/** ------------------文件处理区-------------------- */
// 确保文件 URL 是完整的
const completeFileUrl = computed(() => {
  if (!standard.value.file) return "";
  return standard.value.file.startsWith("http://") ||
    standard.value.file.startsWith("https://")
    ? standard.value.file
    : `http://${standard.value.file}`;
});

/** ------------------数据查询区——表单-------------------- */
// 表单实例
const queryRef = ref<FormInstance>();

// 查询
const query = reactive<QueryParams>({
  page: 1,
  pageSize: 10,
  key: "",
  level: "",
});
const queryParams = toRef(query);
// 数据查询区--> 查询按钮
function handleQuery() {
  queryParams.value.page = 1;
  getList();
  ElMessage.success(JSON.stringify(queryParams.value));
}
// 数据查询区--> 重置按钮
const resetQuery = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.resetFields();
  queryParams.value.page = 1;
  queryParams.value.pageSize = 5;
  getList();
};

/** ------------------数据展示区——表格-------------------- */

// 数据列表
const loading = ref<boolean>(false); // table数据加载遮罩
const total = ref<number>(0); // table数据总数
const tableData = reactive<StandardDTO[]>([]); // table数据
const dataList = toRef(tableData);

// 数据展示区--> 数据加载
const getList = async () => {
  try {
    loading.value = true;
    const response = await listStandardByPage({
      page: queryParams.value.page,
      pageSize: queryParams.value.pageSize,
      key: queryParams.value.key || undefined,
      level: queryParams.value.level || undefined,
    });

    if (response?.code === 1) {
      dataList.value =
        response.data.records.map((record) => ({
          ...record,
          publicationDate: formatDateTime(record.publicationDate),
          implementationDate: formatDateTime(record.implementationDate),
        })) || [];
      total.value = response.data.total || 0;
      // ElMessage.success('获取数据成功')
    } else {
      ElMessage.error(response?.data?.msg || "获取数据失败");
    }
  } catch (error) {
    console.error("获取数据失败:", error);
    ElMessage.error("获取数据失败");
  } finally {
    loading.value = false;
  }
};

/** ------------------数据展示区：数据选择-------------------- */

const ids = ref<string[]>([]); // 表单勾选的id
const single = ref<boolean>(false); // 勾选1个
const multiple = computed(() => ids.value.length > 0);

// 数据展示区--> 勾选数据
function handleSelectionChange(selection: StandardDTO[]) {
  ids.value = selection.map((item: StandardDTO) => item.id);
  single.value = selection.length == 1;
}

/** ------------------数据展示区：分页加载-------------------- */
// 分页--> 修改每页数据数（15｜25｜50）
function handleSizeChange(val: number) {
  queryParams.value.pageSize = val;
  getList();
}

//分页--> 修改当前页
function handleCurrentChange(val: number) {
  queryParams.value.page = val;
  getList();
}

/** ------------------数据操作区——按钮-------------------- */
const router = useRouter();
// 对话框和抽屉控制
const dialogVisible = ref(false);
const drawer = ref(false);
const editingStandard = ref<any>(null);

const uploadComponentRef = ref();

// 数据操作区--> 新增按钮
function handleAdd() {
  // 清空编辑数据
  editingStandard.value = null;
  // 清除上传组件的图片
  uploadComponentRef.value?.clearFiles();
  // 打开对话框
  dialogVisible.value = true;
}

// 数据操作区--> 删除按钮
function handleDelete(row: any) {
  const id = row.id;
  ElMessageBox.confirm(`是否确认删除编号为"${id}"的标准?`, "警告", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(async () => {
      try {
        const response = await deleteStandard(id);
        if (response?.code === 1) {
          ElMessage.success("删除成功");
          getList(); // 刷新列表
        } else {
          ElMessage.error(response?.msg || "删除失败");
        }
      } catch (error) {
        console.error("删除失败:", error);
        ElMessage.error("删除失败，请重试");
      }
    })
    .catch(() => {
      ElMessage.info("已取消删除");
    });
}

// 数据操作区--> 批量删除
function handleDeleteBatch() {
  if (!ids.value || ids.value.length === 0) {
    ElMessage.warning("请选择要删除的标准");
    return;
  }

  ElMessageBox.confirm(
    `是否确认批量删除选中的${ids.value.length}条标准数据?`,
    "警告",
    {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }
  )
    .then(async () => {
      try {
        console.log("批量删除的ids:", ids.value.join(","));
        const response = await deleteStandardBatch(ids.value);
        if (response?.code === 1) {
          ElMessage.success("批量删除成功");
          getList(); // 刷新列表
        } else {
          ElMessage.error(response?.msg || "批量删除失败");
        }
      } catch (error) {
        console.error("批量删除失败:", error);
        ElMessage.error("批量删除失败，请重试");
      }
    })
    .catch(() => {
      ElMessage.info("已取消删除");
    });
}

// 数据操作区-->抽屉查看数据
// const drawer = ref<boolean>(false)
const standardTitle = ref<string>("");
// ... existing code ...
const standard = ref<StandardDTO>({
  id: "",
  level: "",
  standardName: "",
  standardNumber: "",
  responsibleUnit: "",
  departmentName: "",
  draftAuthor: "",
  draftUnit: "",
  scope: "",
  normativeDocuments: "",
  publicationDate: "",
  implementationDate: "",
  image: "",
  imageList: [],
  file: "",
  fileName: "",
});
// ... existing code ...

// 数据操作区--> 查看按钮
function handleView(row: StandardDTO) {
  getStandardById(row.id).then((response) => {
    const data = response.data.standard;

    // 处理图片数据：分割字符串为数组
    standard.value = {
      ...data,
      imageList: data.image
        ? data.image.split(",").filter((url: string) => url.trim())
        : [],
      fileId: response.data.fileId,
      file: response.data.file,
      fileName: response.data.fileName,
    };

    standardTitle.value = "查看标准数据[" + row.id + "]";
  });
  drawer.value = true;
}

// 数据操作区区--> 修改按钮
function handleUpdate(row: StandardDTO) {
  getStandardById(row.id).then((response) => {
    editingStandard.value = {
      ...row,
      fileId: response.data.fileId || "", // 确保 fileId 字段存在
      file: response.data.file || "", // 确保 file 字段存在
      fileName: response.data.fileName || "", // 确保 fileName 字段存在
    };
    console.log("编辑数据:", editingStandard.value);
    // // 清除上传组件的图片
    // uploadComponentRef.value?.clearFiles();
    // // 打开对话框
    // dialogVisible.value = true;
    dialogVisible.value = true; // 打开对话框
  });
}

const handleDesign = async (row: any) => {
  try {
    // 修正参数名为 standardId
    await router.push({
      path: "/caidan",
      query: { standardId: row.id },
    });
  } catch (error) {
    console.error("导航失败:", error);
    ElMessage.error("页面跳转失败");
  }
};
</script>
<style scoped>
.app-container {
  padding: 20px;
}

.box-card {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.search-wrapper {
  padding: 18px 0;
  margin-bottom: 10px;
  background-color: #fff;
  border-radius: 4px;
}

.operation-wrapper {
  margin-bottom: 16px;
}

.table-wrapper {
  margin-bottom: 16px;
  background: #fff;
  border-radius: 4px;
  overflow: auto; /* 允许横向滚动 */
  /* flex: 1; 填充剩余空间 */
  /* min-height: 400px; 最小高度保证 */
}
/* 确保操作按钮列的样式正确 */
:deep(.el-table .operation-column) {
  min-width: 280px;
  /* position: sticky; */
  right: 0;
  background: #fff;
  z-index: 2;
}
.pagination-wrapper {
  padding: 15px;
  text-align: right;
  background: #fff;
  border-radius: 4px;
}

/* 表格内图片列样式 */
.image-preview {
  width: 50px;
  height: 50px;
  border-radius: 4px;
  overflow: hidden;
}

/* 操作按钮样式 */
.operation-buttons {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  gap: 3px; /* 按钮之间的间距 */
}

/* 表单项间距 */
:deep(.el-form-item) {
  margin-bottom: 18px;
  margin-right: 18px;
}

/* 卡片内边距 */
:deep(.el-card__body) {
  padding: 20px;
}

/* 表格内容垂直居中 */
:deep(.el-table .cell) {
  display: flex;
  align-items: center;
  justify-content: center;
}
:deep(.el-table) {
  /* width: 100%!important; 强制宽度自适应 */
  /* table-layout: auto!important; 自动计算列宽 */
}

/* 按钮组样式 */
.mb8 {
  margin-bottom: 8px;
  display: flex;
  gap: 8px;
}

.dialog-footer {
  text-align: right;
}
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
}

/* 操作按钮样式 */
:deep(.el-button--link) {
  padding: 4px 8px;
  height: 28px;
  font-size: 13px;
}

:deep(.el-button--link:hover) {
  background-color: #f5f7fa;
  border-radius: 4px;
}

/* 不同类型按钮的颜色 */
:deep(.el-button--primary.is-link) {
  color: #409eff;
}

:deep(.el-button--danger.is-link) {
  color: #f56c6c;
}

:deep(.el-button--info.is-link) {
  color: #909399;
}

:deep(.el-button--success.is-link) {
  color: #67c23a;
}

/* 表格列宽度调整 */
:deep(.el-table .operation-column) {
  min-width: 280px;
}

/* 表格内容截断 */
:deep(.custom-table .el-table__body .cell) {
  display: -webkit-box;
  -webkit-line-clamp: 1; /* 限制显示 1 行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px; /* 根据列宽调整 */
  white-space: normal; /* 允许换行（配合行数限制） */
}

.operation-buttons {
  display: flex;
  flex-direction: column; /* 垂直排列 */
  gap: 3px; /* 行间距 */
  padding: 4px 0; /* 上下留白 */
}

.button-group {
  display: flex;
  gap: 3px;
  justify-content: center; /* 水平居中 */
  flex-wrap: nowrap; /* 禁止换行 */
}

/* 调整操作列宽度 */
:deep(.el-table .el-table__cell:last-child) {
  min-width: 280px;
  /* padding: 12px 16px !important; 增加上下间距 */
}
</style>
